import { render, staticRenderFns } from "./diseaseMangement.vue?vue&type=template&id=f9e752ae"
import script from "./diseaseMangement.vue?vue&type=script&lang=js"
export * from "./diseaseMangement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9e752ae')) {
      api.createRecord('f9e752ae', component.options)
    } else {
      api.reload('f9e752ae', component.options)
    }
    module.hot.accept("./diseaseMangement.vue?vue&type=template&id=f9e752ae", function () {
      api.rerender('f9e752ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/diseaseMangement.vue"
export default component.exports